import sha1 from 'js-sha1';
import uuidv4 from 'uuid/v4';
import sha256 from 'sha256';

export default class Utils {
  static capitalizeFirstLetter(s) {
    let firstLetter = s.charAt(0);
    firstLetter = firstLetter.toUpperCase();
    return firstLetter + s.slice(1);
  }

  /**
     * @returns {string} 40 alphanumeric chars (SHA1)
     */
  static generateUID() {
    return sha1(uuidv4() + uuidv4() + (new Date()).getTime());
  }

  static getQueryParams() {
    let queryString = document.location.search;

    if (queryString) {
      queryString = queryString.slice(1);
      const queryPairs = queryString.split('&');
      const params = {};

      queryPairs.forEach(element => {
        const pair = element.split('=');
        params[pair[0]] = pair[1] ? pair[1] : '';
      });

      this.queryParams = params;
    } else {
      this.queryParams = {};
    }

    return this.queryParams;
  }

  static getOrigin(url) {
    const splittedUrl = url.split('/');

    if (splittedUrl.length < 3) {
      return '';
    }

    return splittedUrl[0] + '//' + splittedUrl[2];
  }

  static hashEmail(email) {
    return sha256(email);
  }
}



// WEBPACK FOOTER //
// ./src/common/modules/utils.js